import "./SuccessPage.css";

import React from "react";

import {  useEffect } from "react";



export const SuccessPage = ({ changeNavBar }) => {
  useEffect(() => {
    let href = window.location.href;
    let subHref = href.split("/")[3];
    if (subHref === "success") {
      changeNavBar("", "rgba(41, 41, 41)", "white", "black");
    }
  }, []);
  return (
    <div className="success-page-container">
      <h1 className="success-page-h1">
        Purchase successfull, check you Email for more information.
      </h1>
    </div>
  );
};
